import React, { useEffect, useRef, useState, useContext } from 'react';
import Chart from 'chart.js/auto';
import { ApiContext } from '../../../../../context/MyContext';
import * as userService from '../../../../../service/userService';
import StepsGraphModal from '../DataGraphs/StepsGraphModal';
import Button from '../../../../../common/Button/Button';

const StepsChart = ({ profileId, selectedDate, eventTypeId }) => {
    const chartRef = useRef(null);
    const { get } = useContext(ApiContext);
    const [value, setValue] = useState(0);
    const [recommended, setRecommended] = useState(10000);
    const [hasData, setHasData] = useState(true);
    const [showGraph, setShowGraph] = useState(false);
    const chartInstanceRef = useRef(null);
    useEffect(() => {
      if (!eventTypeId) return;
      const fetchSteps = async () => {
        const result = await userService.fetchStepsSummary(get, profileId, 'D', selectedDate, eventTypeId);
        if (result.success && result.data.length > 0 && result.data[0].value > 0) {
            const { value, recommended } = result.data[0];
            setValue(value);
            setRecommended(recommended);
            setHasData(true);
          } else {
            setHasData(false);
          }
      };
      fetchSteps();
    }, [profileId, selectedDate, eventTypeId]);
  
    useEffect(() => {
        if (!chartRef.current || !hasData) return;

        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }
        chartInstanceRef.current = new Chart(chartRef.current, {
        type: 'doughnut',
        data: {
          labels: ['Steps', 'Remaining'],
          datasets: [{
            data: [value, Math.max(recommended - value, 0)],
            backgroundColor: ['#FF6414', '#FFF0E8'],
            borderWidth: 0
          }]
        },
        options: {
          rotation: -90,
          circumference: 180,
          cutout: '70%',
          plugins: {
            legend: { display: false }
          }
        }
      });
      return () => chartInstanceRef.current?.destroy();
    }, [hasData,value, recommended]);
  
    return (
        <div className="bg-white rounded-xl shadow-md w-[260px] h-[360px] flex flex-col items-center justify-center text-center p-4">
       <div className="text-xl font-semibold leading-tight"> Steps Analytics </div>
        {hasData ? (
          <>
            <div className="flex-1 w-full">
              <canvas ref={chartRef} className="w-full h-full" />
            </div>
            <div className="py-2">
              <p className="text-sm font-semibold leading-tight">
                Steps<br />{value} steps
              </p>
            </div>
          </>
        ) : (
          <p className="text-sm text-gray-500 font-medium">
            No Steps data available<br /> for the day. <br/> Remind the client to Track the Data.
          </p>
        )}
         <div>
      <Button  
       text = "View Trends" 
       onClick={() => setShowGraph(true)} 
       className="bg-orange-primary hover:bg-dark-orange w-32"/>
      </div>
       
{showGraph && (
  <StepsGraphModal
    profileId={profileId}
    selectedDate={selectedDate}
    eventTypeId={eventTypeId}
    onClose={() => setShowGraph(false)}
  />
)}
      </div>
    );
  };
  
  export default StepsChart;